import { render } from "@projectComps/ProjectDeleteConfirm/ProjectDeleteConfirm.html?vue&type=template&id=04d4a1da&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@projectComps/ProjectDeleteConfirm/ProjectDeleteConfirm.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__